<div *ngIf="!isLoading" style="min-height: 70vh;" class="pt-5 pb-5"
    [ngClass]="{'container-fluid' : isHandset$,'container' : !isHandset$}">

    <div class="row">
        <div class="col-12 text-center">
            <mat-icon class="text-success w-100 h-100" style="font-size: 5em;">check_circle</mat-icon>
        </div>

        <div class="col-12 text-center">
            <p class="mb-3">Your account has been activated with success!</p>
            <button mat-raised-button color="primary" (click)="onClickHereToLogin()">Login</button>
        </div>

    </div>
</div>

<div style="min-height: 70vh;" class="mt-5 pt-5" *ngIf="isLoading">
    <mat-spinner [diameter]="60" [strokeWidth]="5" class="mx-auto mt-5">
    </mat-spinner>
</div>